import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const items = [
  {
    q: "How is Prospectivly different from hiring SDRs or an agency?",
    a: "Agencies give you activity reports. SDRs give you ramps, churn and overhead. We run a single end-to-end engine across ICP, infra, outreach, qualification and booking; and you pay for outcomes, not seats or sends.",
  },
  {
    q: "What does ‘BANT-aligned qualification’ mean in practice?",
    a: "Every meeting that reaches your reps comes with explicit Budget, Authority, Need and Timing signals captured during outreach, plus pre-call notes and conversation hooks. No raw leads.",
  },
  {
    q: "Which industries do you work best with?",
    a: "B2B SaaS, FinTech, BFSI, and service businesses trust us to connect them with qualified buyers. If your business grows through high-quality sales meetings, we'll help you put more of them on the calendar.",
  },
  {
    q: "Do we still own our pipeline data?",
    a: "Yes. Every lead, every interaction and every meeting is yours.",
  },
  {
    q: "Is pricing performance-based?",
    a: "Yes. We run on a pure pay-per-meeting model, so you only pay for qualified meetings that actually land on your calendar; no retainers, no seat fees, no vanity activity.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-36 bg-[#0B0D12]"
    >
      <div className="max-w-[1100px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="mb-12 max-w-3xl">
          <p className="text-xs uppercase tracking-[0.3em] text-[#FF4500] mb-4">
            FAQ
          </p>
          <h2 className="font-editorial font-light text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tighter">
            Questions revenue teams
            <br /> <span className="italic">actually ask.</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {items.map((it, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-[#2A2E3D] py-2"
            >
              <AccordionTrigger
                className="text-left font-editorial text-2xl md:text-3xl text-[#EDEDED] hover:text-[#FF4500] hover:no-underline py-6 [&[data-state=open]]:text-[#FF4500]"
              >
                {it.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#9CA3AF] text-base md:text-lg leading-relaxed pb-8 pr-6">
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
